import React, { forwardRef, useContext } from 'react';
import Link from './components/Link/index.js';
import { CoreContext } from './context/index.js';

const Logo = forwardRef(({ url, img, onClick }, ref) => {
    const { data } = useContext(CoreContext);
    const { siteName } = data.siteConfig;
    return (React.createElement("span", { ref: ref, className: "main-logo", "aria-label": siteName, "data-event-name": "bloc_interact", "data-bloc-name": "header logo" },
        React.createElement(Link, { href: url, className: "logo", title: img.alt, img: img.src, ariaLabel: siteName, onClick: onClick })));
});
Logo.displayName = 'Logo';

export { Logo as L };
//# sourceMappingURL=Logo-fy1HhiD6.js.map
